import { portalAPI } from './portalAPI';

const APISageHrSlice = portalAPI.injectEndpoints({
    endpoints: (builder) => ({
        isSageHrEnabled: builder.query<boolean, void>({
            query: () => '/v1/integrations/sage-hr/enabled',
        }),
    }),
    overrideExisting: false,
});

export const { useIsSageHrEnabledQuery } = APISageHrSlice;
